import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Currency formatting
export const CURRENCY_SYMBOLS = {
  USD: "$",
  CZK: "Kč",
  EUR: "€"
};

export const formatCurrency = (amount, currency = "USD") => {
  const symbol = CURRENCY_SYMBOLS[currency] || "$";
  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
  
  if (currency === "CZK") {
    return `${formatted} ${symbol}`;
  }
  return `${symbol}${formatted}`;
};

// Date-only values (issue_date, due_date) are YYYY-MM-DD strings and
// must stay in the user's local calendar. Never feed them to
// `new Date(string)`: that parses as UTC midnight, which renders as
// the PREVIOUS day anywhere west of Greenwich.
export const parseLocalDate = (ymd) => {
  const [y, m, d] = ymd.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const formatYMD = (date) => {
  const p = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${p(date.getMonth() + 1)}-${p(date.getDate())}`;
};

export const todayYMD = () => formatYMD(new Date());

export const addDaysYMD = (ymd, days) => {
  const d = parseLocalDate(ymd);
  d.setDate(d.getDate() + days);
  return formatYMD(d);
};

// Date formatting
export const formatDate = (dateString) => {
  if (!dateString) return "";
  // Date-only strings parse in the local calendar; full timestamps
  // keep normal Date parsing (they carry their own zone).
  const date = /^\d{4}-\d{2}-\d{2}$/.test(dateString)
    ? parseLocalDate(dateString)
    : new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

// Status badge styles
export const getStatusBadgeClass = (status) => {
  switch (status) {
    case "created":
      return "bg-slate-100 text-slate-700 border-slate-200";
    case "sent":
      return "bg-blue-50 text-blue-700 border-blue-200";
    case "paid":
      return "bg-green-50 text-green-700 border-green-200";
    case "cancelled":
      return "bg-red-50 text-red-700 border-red-200";
    default:
      return "bg-slate-100 text-slate-700 border-slate-200";
  }
};

// Local storage helpers
export const storage = {
  get: (key) => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch {
      return null;
    }
  },
  set: (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Ignore storage errors
    }
  },
  remove: (key) => {
    try {
      localStorage.removeItem(key);
    } catch {
      // Ignore storage errors
    }
  }
};

// Auth helpers
export const getAuthHeader = () => {
  const token = storage.get('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};
